// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 720px) {
  .rates-section {
    gap: 0px;
    padding: 0px;
    width: 100%;
  }
}

@media (max-width: 720px) {
  .rates-section__top {
    padding: 10px;
  }
}
.rates-section__top__menus {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
@media (max-width: 720px) {
  .rates-section__top__menus {
    flex-direction: column;
  }
}
.rates-section__top__menus__item {
  padding: 8px !important;
  border-radius: 10px;
  background-color: #F5EFE7;
}
@media (max-width: 720px) {
  .rates-section__top__menus__item {
    min-height: 40px;
  }
}
.rates-section__top__menus__item div:first-child > div:first-child {
  display: inline-block;
}
.rates-section__top__menus__item div:first-child > div:first-child::first-letter {
  font-family: Twemoji Country Flags, Segoe UI Emoji, NotoColorEmoji, sans-serif;
  text-shadow: -0.5px -0.5px 0 #3E5879, 0.5px -0.5px 0 #3E5879, -0.5px 0.5px 0 #3E5879, 0.5px 0.5px 0 #3E5879;
}
.rates-section__top__menus__modal button {
  display: inline-block;
  text-align: left;
}
.rates-section__top__menus__modal button::first-letter {
  font-family: Twemoji Country Flags, Segoe UI Emoji, NotoColorEmoji, sans-serif;
  text-shadow: -0.5px -0.5px 0 #3E5879, 0.5px -0.5px 0 #3E5879, -0.5px 0.5px 0 #3E5879, 0.5px 0.5px 0 #3E5879;
}
.rates-section__top__menus__base-currency-selector {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  box-shadow: none !important;
}
.rates-section__top__menus__base-currency-selector:hover {
  cursor: pointer;
  background-color: #fff9f2;
  outline: 1px solid #213555;
  box-shadow: none !important;
}
.rates-section__top__menus__base-target-switch {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  gap: 8px;
}
.rates-section__top__menus__base-target-switch:hover {
  background-color: #fff9f2;
  outline: 1px solid #213555;
}
.rates-section__top__menus__base-target-switch--reverse {
  flex-direction: row-reverse;
}
.rates-section__top .rates-section__top__details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-top: 4px;
}
.rates-section__top .rates-section__top__details__item {
  min-height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  border-radius: 10px;
  text-align: left;
  font-size: 14px;
}
@media (max-width: 720px) {
  .rates-section__top .rates-section__top__details__item {
    font-size: 11px;
  }
}
@media (max-width: 720px) {
  .rates-section__top .rates-section__top__details__item__example {
    flex-direction: column;
    align-self: stretch;
    align-items: center;
    justify-content: center;
  }
}
.rates-section__top .rates-section__top__details__item__example__title {
  font-size: 14px;
  font-weight: bold;
}
@media (max-width: 720px) {
  .rates-section__top .rates-section__top__details__item__example__title {
    display: none;
  }
}

.rates-section__iso-names-switch {
  display: flex;
  flex-direction: row;
  gap: 10px;
  color: #213555;
  font-weight: bold;
}
.rates-section__iso-names-switch__checkbox {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f1e2d7;
  outline: 1px solid #D8C4B6;
  font-size: 20px;
}
.rates-section__iso-names-switch:hover > .rates-section__iso-names-switch__checkbox {
  background-color: #F5EFE7;
  outline: 1px solid #213555;
}`, "",{"version":3,"sources":["webpack://./src/sections/RatesSection/RatesSection.scss","webpack://./src/utils/_themeConstants.scss"],"names":[],"mappings":"AAGE;EADF;IAEI,QAAA;IACA,YAAA;IACA,WAAA;EADF;AACF;;AAKE;EADF;IAEI,aAAA;EADF;AACF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAFJ;AAII;EALF;IAMI,sBAAA;EADJ;AACF;AAGI;EACE,uBAAA;EACA,mBAAA;EACA,yBCpBS;ADmBf;AAGM;EALF;IAMI,gBAAA;EAAN;AACF;AAEM;EACE,qBAAA;AAAR;AACQ;EACE,8EAAA;EAEA,2GACA;AADV;AAUM;EACE,qBAAA;EACA,gBAAA;AARR;AASQ;EACE,8EAAA;EAEA,2GACA;AATV;AAiBI;EAEE,wBAAA;EACA,qBAAA;EACA,gBAAA;EAEA,SAAA;EACA,2BAAA;AAjBN;AAmBM;EACE,eAAA;EACA,yBClEU;EDmEV,0BAAA;EACA,2BAAA;AAjBR;AAqBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,QAAA;AApBN;AAsBM;EACE,yBCtFU;EDuFV,0BAAA;AApBR;AAuBM;EACE,2BAAA;AArBR;AA0BE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAxBJ;AA0BI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,mBAAA;EAEA,gBAAA;EACA,eAAA;AAzBN;AA2BM;EAZF;IAaI,eAAA;EAxBN;AACF;AA2BQ;EADF;IAEI,sBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;EAxBR;AACF;AAyBQ;EACE,eAAA;EACA,iBAAA;AAvBV;AAyBU;EAJF;IAKI,aAAA;EAtBV;AACF;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cCxJW;EDyJX,iBAAA;AA1BF;AA4BE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,yBC7JW;ED8JX,0BAAA;EAEA,eAAA;AA5BJ;AAgCI;EACE,yBCnKS;EDoKT,0BAAA;AA9BN","sourcesContent":["@use \"../../utils/themeConstants\";\r\n\r\n.rates-section {\r\n  @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n    gap: 0px;\r\n    padding: 0px;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.rates-section__top {\r\n  @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n    padding: 10px;\r\n  }\r\n\r\n  $menu-paddings: 8px;\r\n  &__menus {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 10px;\r\n\r\n    @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n      flex-direction: column;\r\n    }\r\n\r\n    &__item {\r\n      padding: $menu-paddings !important;\r\n      border-radius: 10px;\r\n      background-color: themeConstants.$color-bright;\r\n\r\n      @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n        min-height: 40px;\r\n      }\r\n\r\n      div:first-child > div:first-child {\r\n        display: inline-block;\r\n        &::first-letter {\r\n          font-family: Twemoji Country Flags, Segoe UI Emoji, NotoColorEmoji, sans-serif;\r\n          $flag-outline-color: themeConstants.$color-dark-highlight;\r\n          text-shadow: \r\n          -0.5px -0.5px 0 $flag-outline-color,\r\n          0.5px -0.5px 0 $flag-outline-color,\r\n          -0.5px  0.5px 0 $flag-outline-color,\r\n          0.5px  0.5px 0 $flag-outline-color;\r\n        }\r\n      }\r\n    }\r\n\r\n    &__modal {\r\n      button {\r\n        display: inline-block;\r\n        text-align: left;\r\n        &::first-letter {\r\n          font-family: Twemoji Country Flags, Segoe UI Emoji, NotoColorEmoji, sans-serif;\r\n          $flag-outline-color: themeConstants.$color-dark-highlight;\r\n          text-shadow: \r\n          -0.5px -0.5px 0 $flag-outline-color,\r\n          0.5px -0.5px 0 $flag-outline-color,\r\n          -0.5px  0.5px 0 $flag-outline-color,\r\n          0.5px  0.5px 0 $flag-outline-color;\r\n        }\r\n      }\r\n    }\r\n\r\n    &__base-currency-selector {\r\n      // remove default dropdown appearance in different browsers\r\n      -webkit-appearance: none;\r\n      -moz-appearance: none;\r\n      appearance: none;\r\n    \r\n      border: 0;\r\n      box-shadow: none !important;\r\n    \r\n      &:hover {\r\n        cursor: pointer;\r\n        background-color: themeConstants.$color-brightest;\r\n        outline: 1px solid themeConstants.$color-dark;\r\n        box-shadow: none !important;\r\n      }\r\n    }\r\n\r\n    &__base-target-switch {\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: center;\r\n      align-items: center;\r\n\r\n      display: flex;\r\n      flex-direction: row;\r\n      align-items: center;\r\n      justify-content: center;\r\n      font-size: 14px;\r\n      gap: 8px;\r\n\r\n      &:hover {\r\n        background-color: themeConstants.$color-brightest;\r\n        outline: 1px solid themeConstants.$color-dark;\r\n      }\r\n\r\n      &--reverse {\r\n        flex-direction: row-reverse;\r\n      }\r\n    }\r\n  }\r\n\r\n  .rates-section__top__details {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 4px;\r\n    margin-top: 4px;\r\n\r\n    &__item {\r\n      min-height: 32px;\r\n      display: flex;\r\n      flex-direction: row;\r\n      align-items: center;\r\n      justify-content: flex-start;\r\n      gap: 8px;\r\n      border-radius: 10px;\r\n\r\n      text-align: left;\r\n      font-size: 14px;\r\n\r\n      @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n        font-size: 11px;\r\n      }  \r\n\r\n      &__example {\r\n        @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n          flex-direction: column;\r\n          align-self: stretch;\r\n          align-items: center;\r\n          justify-content: center;\r\n        }  \r\n        &__title {\r\n          font-size: 14px;\r\n          font-weight: bold;\r\n\r\n          @media(max-width: themeConstants.$mobile-cutoff-width) {\r\n            display: none;\r\n          }  \r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.rates-section__iso-names-switch {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 10px;\r\n  color: themeConstants.$color-dark;\r\n  font-weight: bold;\r\n\r\n  &__checkbox {\r\n    width: 24px;\r\n    height: 24px;\r\n    border-radius: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    background-color: themeConstants.$color-light1;\r\n    outline: 1px solid themeConstants.$color-medium;\r\n\r\n    font-size: 20px;\r\n  }\r\n\r\n  &:hover {\r\n    > .rates-section__iso-names-switch__checkbox {\r\n      background-color: themeConstants.$color-bright;\r\n      outline: 1px solid themeConstants.$color-dark;\r\n    }\r\n  }\r\n}","$color-dark: #213555;\r\n$color-dark-highlight: #3E5879;\r\n\r\n$color-medium: #D8C4B6;\r\n\r\n$color-light: #ebd9cd;\r\n$color-light1: #f1e2d7;\r\n\r\n$color-bright: #F5EFE7;\r\n$color-brightest: #fff9f2;\r\n\r\n$mobile-cutoff-width: 720px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
